// Mock data for the KontrataPH V3 prototype. Not connected to a backend.
// Peso helper
export const peso = (n: number) => "₱" + Number(n ?? 0).toLocaleString("en-PH");

export type Category = { key: string; label: string; icon: string; count: number };
export const categories: Category[] = [
  { key: "construction", label: "Construction & Trade", icon: "HardHat", count: 4820 },
  { key: "professional", label: "Professional Services", icon: "Briefcase", count: 3110 },
  { key: "it", label: "IT & Digital Services", icon: "Laptop", count: 2740 },
  { key: "business", label: "Business Services", icon: "Building2", count: 1560 },
  { key: "logistics", label: "Logistics & Transport", icon: "Truck", count: 1290 },
  { key: "home", label: "Home & Personal", icon: "Home", count: 2010 },
  { key: "supplies", label: "Supplies & Equipment", icon: "Package", count: 980 },
  { key: "others", label: "Others", icon: "MoreHorizontal", count: 640 },
];

export type Person = {
  id: string; name: string; title: string; city: string; rating: number; reviews: number;
  years: number; verified: boolean; available: boolean; rate: string; skills: string[]; initials: string;
};
export const people: Person[] = [
  { id: "juan-dela-cruz", name: "Juan Dela Cruz", title: "Licensed Electrician", city: "Quezon City", rating: 4.8, reviews: 128, years: 8, verified: true, available: true, rate: "₱600/day", skills: ["Electrical Wiring", "Maintenance", "Troubleshooting"], initials: "JD" },
  { id: "maria-santos", name: "Maria Santos", title: "Virtual Assistant", city: "Cebu City", rating: 4.9, reviews: 64, years: 5, verified: true, available: true, rate: "₱350/hr", skills: ["Admin", "Bookkeeping", "CRM"], initials: "MS" },
  { id: "mark-rivera", name: "Mark Rivera", title: "Plumber / Pipefitter", city: "Makati City", rating: 4.7, reviews: 41, years: 6, verified: true, available: false, rate: "₱550/day", skills: ["Plumbing", "Fitting", "Repair"], initials: "MR" },
  { id: "ana-gomez", name: "Ana Gomez", title: "Accountant, CPA", city: "Pasig City", rating: 4.9, reviews: 52, years: 9, verified: true, available: true, rate: "₱900/hr", skills: ["Tax", "Audit", "Payroll"], initials: "AG" },
  { id: "rodel-valencia", name: "Rodel Valencia", title: "Heavy Equipment Operator", city: "Bulacan", rating: 4.6, reviews: 33, years: 11, verified: true, available: true, rate: "₱850/day", skills: ["Backhoe", "Crane", "Safety"], initials: "RV" },
  { id: "janina-cruz", name: "Janina Cruz", title: "Full-Stack Developer", city: "Taguig City", rating: 4.9, reviews: 77, years: 7, verified: true, available: true, rate: "₱1,200/hr", skills: ["React", "Node", "AWS"], initials: "JC" },
];

export type Service = {
  id: string; title: string; by: string; company?: boolean; city: string; rating: number; reviews: number;
  from: number; verified: boolean; tags: string[];
};
export const services: Service[] = [
  { id: "ac-install", title: "Air-Conditioning Installation & Repair", by: "Roberto Santos", city: "Cavite & Metro Manila", rating: 4.9, reviews: 86, from: 1500, verified: true, tags: ["Installation", "Repair", "Cleaning"] },
  { id: "gen-construction", title: "General Construction & Renovation", by: "ABC Construction Corp.", company: true, city: "Metro Manila & Luzon", rating: 4.6, reviews: 54, from: 50000, verified: true, tags: ["PCAB AAA", "Design & Build"] },
  { id: "plumbing-svc", title: "Plumbing Services", by: "Maria Plumbing", city: "Metro Manila", rating: 4.7, reviews: 39, from: 800, verified: true, tags: ["Leak Repair", "Fitting"] },
  { id: "web-dev", title: "Web & Mobile Development", by: "DevSolutions", company: true, city: "Remote / PH", rating: 4.8, reviews: 61, from: 60000, verified: true, tags: ["Web", "Mobile", "UI/UX"] },
  { id: "interior", title: "Interior Design", by: "Design Hub PH", company: true, city: "Makati City", rating: 4.6, reviews: 28, from: 35000, verified: true, tags: ["Residential", "Commercial"] },
  { id: "solar-install", title: "Solar Panel Installation", by: "SolarTech Philippines", company: true, city: "Laguna", rating: 4.7, reviews: 44, from: 120000, verified: true, tags: ["Solar", "Off-grid"] },
];

export type Company = {
  id: string; name: string; tagline: string; city: string; rating: number; reviews: number;
  verified: boolean; tags: string[]; since: string; initials: string;
};
export const companies: Company[] = [
  { id: "abc-construction", name: "ABC Construction Corp.", tagline: "Building quality structures. Delivering with integrity.", city: "Quezon City", rating: 4.6, reviews: 36, verified: true, tags: ["Construction", "General Contractor", "Design & Build"], since: "Aug 2020", initials: "AC" },
  { id: "xyz-manpower", name: "XYZ Manpower Services", tagline: "Reliable manpower & recruitment.", city: "Makati City", rating: 4.4, reviews: 22, verified: true, tags: ["Manpower", "Recruitment"], since: "Jan 2019", initials: "XM" },
  { id: "solartech", name: "SolarTech Philippines", tagline: "Powering Filipino homes with clean energy.", city: "Laguna", rating: 4.7, reviews: 44, verified: true, tags: ["Solar", "Electrical"], since: "Mar 2021", initials: "ST" },
  { id: "devsolutions", name: "DevSolutions Inc.", tagline: "Software that ships.", city: "Taguig City", rating: 4.8, reviews: 61, verified: true, tags: ["Software", "IT"], since: "Jun 2018", initials: "DS" },
];

export type Job = {
  id: string; title: string; company: string; city: string; salary: string; type: string;
  posted: string; applicants: number; tags: string[];
};
export const jobs: Job[] = [
  { id: "heavy-eq-op", title: "Heavy Equipment Operator", company: "XYZ Development Corp.", city: "Bulacan", salary: "₱25,000–₱35,000/mo", type: "Full-time", posted: "2 days ago", applicants: 12, tags: ["On-site", "Construction"] },
  { id: "sales-mgr", title: "Sales Manager", company: "ABC Marketing Inc.", city: "Makati City", salary: "₱40,000–₱60,000/mo", type: "Full-time", posted: "1 day ago", applicants: 20, tags: ["Sales", "Leadership"] },
  { id: "accountant", title: "Accountant", company: "XYZ Trading Corp.", city: "Quezon City", salary: "₱25,000–₱35,000/mo", type: "Full-time", posted: "3 days ago", applicants: 8, tags: ["Finance", "CPA"] },
  { id: "site-engineer", title: "Site Engineer", company: "ABC Construction Corp.", city: "Taguig City", salary: "₱35,000–₱45,000/mo", type: "Full-time", posted: "2 days ago", applicants: 15, tags: ["Engineering", "On-site"] },
  { id: "warehouse-staff", title: "Warehouse Staff", company: "Logistics Philippines", city: "Bulacan", salary: "₱18,000–₱22,000/mo", type: "Full-time", posted: "5 days ago", applicants: 30, tags: ["Logistics"] },
];

export type Project = {
  id: string; title: string; category: string; location: string; budget: number; budgetType: string;
  deadline: string; bids: number; owner: string; ownerSince: string; posted: string; duration: string;
  paymentTerms: string; description: string; scope: string[]; requirements: string[];
  licenses: string[]; attachments: number; timeline: { label: string; date: string }[];
};
export const projects: Project[] = [
  {
    id: "2storey-residential",
    title: "Construction of 2-Storey Residential Building",
    category: "Building Construction",
    location: "Cavite",
    budget: 6000000, budgetType: "Estimated",
    deadline: "August 28, 2026",
    bids: 12, owner: "Juan Dela Cruz", ownerSince: "May 2023", posted: "Aug 1, 2026",
    duration: "6 months", paymentTerms: "Upon Milestone",
    description:
      "We are looking for a qualified contractor for the construction of a 2-storey residential building including materials, labor, equipment and other necessary works.",
    scope: [
      "Site preparation and mobilization", "Foundation and structural works", "Masonry and wall finishing",
      "Electrical installation", "Plumbing and sanitary works", "Carpentry and joinery",
      "Painting and final finishing", "Cleaning and turnover",
    ],
    requirements: ["Lot Area: 120 sqm", "Floor Area: 180 sqm", "3 Bedrooms, 2 Toilet & Bath", "Carport and Balcony"],
    licenses: ["PCAB License (any category)", "Business Permit", "BIR Registration"],
    attachments: 6,
    timeline: [
      { label: "Project Posted", date: "Aug 1, 2026" },
      { label: "Open for Bidding", date: "Aug 1 – Aug 28, 2026" },
      { label: "Shortlisting", date: "Aug 29 – Sept 3, 2026" },
      { label: "Negotiation", date: "Sept 4 – Sept 8, 2026" },
      { label: "Awarding", date: "Sept 9, 2026" },
      { label: "Contract Signed", date: "Sept 15, 2026" },
      { label: "Project Start", date: "Sept 20, 2026" },
    ],
  },
  {
    id: "office-supply",
    title: "Supply of Office Furniture",
    category: "Supply Contract",
    location: "Makati City", budget: 800000, budgetType: "Fixed",
    deadline: "Aug 20, 2026", bids: 8, owner: "Corporate Hub Inc.", ownerSince: "2022", posted: "Aug 2, 2026",
    duration: "45 days", paymentTerms: "50% down, 50% on delivery",
    description: "Supply and delivery of office furniture for a new 3-floor office fit-out.",
    scope: ["Workstations (60 units)", "Ergonomic chairs", "Meeting room tables", "Storage cabinets", "Delivery & installation"],
    requirements: ["DTI/SEC registration", "Sample catalog", "Warranty terms"],
    licenses: ["Business Permit", "BIR Registration"],
    attachments: 3,
    timeline: [
      { label: "Project Posted", date: "Aug 2, 2026" },
      { label: "Open for Bidding", date: "Aug 2 – Aug 20, 2026" },
      { label: "Awarding", date: "Aug 24, 2026" },
    ],
  },
  {
    id: "it-system",
    title: "IT System Development",
    category: "IT Systems", location: "Quezon City", budget: 1500000, budgetType: "Fixed",
    deadline: "Aug 30, 2026", bids: 10, owner: "GovServe LGU", ownerSince: "2021", posted: "Aug 3, 2026",
    duration: "4 months", paymentTerms: "Milestone-based",
    description: "Development of an internal records and permits management system with reporting.",
    scope: ["Requirements & design", "Backend + database", "Web portal", "Reporting dashboard", "Training & handover"],
    requirements: ["Portfolio of similar systems", "Team CVs", "Data privacy compliance"],
    licenses: ["SEC registration", "BIR Registration"],
    attachments: 4,
    timeline: [
      { label: "Project Posted", date: "Aug 3, 2026" },
      { label: "Open for Bidding", date: "Aug 3 – Aug 30, 2026" },
      { label: "Awarding", date: "Sept 5, 2026" },
    ],
  },
];

export type Rfq = {
  id: string; title: string; category: string; location: string; deadline: string;
  owner: string; quotes: number; status: string; items: { name: string; qty: number; unit: string }[];
  detail: { description?: string; terms?: string };
};
export const rfqs: Rfq[] = [
  {
    id: "cement-rebar-supply", title: "Supply of Cement & Rebar", category: "Supply", location: "Cavite",
    deadline: "Sept 15, 2026", owner: "Juan Dela Cruz", quotes: 4, status: "open",
    items: [
      { name: "Portland Cement", qty: 300, unit: "bags" },
      { name: "Rebar 10mm", qty: 120, unit: "lengths" },
      { name: "Rebar 12mm", qty: 80, unit: "lengths" },
    ],
    detail: { description: "For a 2-storey residential build. Delivery to site in Cavite.", terms: "50% down, 50% on delivery" },
  },
  {
    id: "office-it-equipment", title: "Office IT Equipment", category: "Supply", location: "Makati City",
    deadline: "Aug 30, 2026", owner: "Corporate Hub Inc.", quotes: 6, status: "open",
    items: [
      { name: "Laptops (i5, 16GB)", qty: 20, unit: "units" },
      { name: "Monitors 24\"", qty: 20, unit: "units" },
    ],
    detail: { description: "New office fit-out. Warranty required.", terms: "Net 30" },
  },
];

export const trust = [
  { icon: "ShieldCheck", title: "Verified Identities", sub: "Real people, real profiles" },
  { icon: "FileSignature", title: "Secure Contracts", sub: "Legally-aware agreements" },
  { icon: "Wallet", title: "Safe Payments", sub: "Escrow & milestone protection" },
  { icon: "Star", title: "Real Reviews", sub: "Transparent feedback system" },
];

export const postTypes = [
  { key: "resume", title: "Post My Resume", sub: "Show your experience and skills", icon: "FileText" },
  { key: "service", title: "Offer a Service", sub: "Advertise your personal services", icon: "Wrench" },
  { key: "company", title: "Create a Company Page", sub: "Build your business presence", icon: "Building2" },
  { key: "company-service", title: "Advertise Company Services", sub: "List your company's services", icon: "Megaphone" },
  { key: "job", title: "Post a Job Opening", sub: "Find employees for your business", icon: "Briefcase" },
  { key: "project", title: "Post a Project for Bidding", sub: "Invite contractors to bid", icon: "FolderKanban" },
  { key: "rfq", title: "Request a Quotation", sub: "Ask for price quotations", icon: "ReceiptText" },
  { key: "item", title: "Sell an Item / Equipment", sub: "List items for sale or rent", icon: "Package" },
];

export const activities = [
  { key: "find-work", title: "Find Work", sub: "Post a résumé and apply for jobs", icon: "UserRound" },
  { key: "offer-service", title: "Offer a Service", sub: "Advertise personal or professional services", icon: "Wrench" },
  { key: "promote-company", title: "Promote a Company", sub: "Create a business page and list services", icon: "Building2" },
  { key: "hire", title: "Hire Someone", sub: "Find workers, professionals, or companies", icon: "Users" },
  { key: "post-job", title: "Post a Job", sub: "Advertise full-time, part-time, or contractual jobs", icon: "Briefcase" },
  { key: "post-project", title: "Post a Project", sub: "Request proposals, quotations, or competitive bids", icon: "FolderKanban" },
];

// Homepage platform stats (prototype placeholders — replace with real metrics before launch)
export const stats = [
  { big: "12,480", lbl: "Verified Workers" },
  { big: "3,210", lbl: "Open Jobs" },
  { big: "1,940", lbl: "Completed Contracts" },
  { big: "68", lbl: "Cities & Provinces" },
];
